import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/analytics-1.4-apis/analytics-1.4-apis/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const CodeBlock = makeShortcode("CodeBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "adobe-analytics-data-insertion-api"
    }}>{`Adobe Analytics Data Insertion API`}</h1>
    <p>{`The Data Insertion API provides a mechanism for server-side data collection and submission to Adobe data collection servers. Instead of using AppMeasurement installed on each web page, server-side data collection collects data based solely on API requests and responses. While this implementation method cannot capture all data that is available via page-based beacons, it provides valuable insight into user activity without the overhead associated with attaching JavaScript to every page.`}</p>
    <InlineAlert variant="note" slots="text" mdxType="InlineAlert" />
    <p>{`Data Insertion API and `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/analytics-apis/docs/2.0/guides/endpoints/bulk-data-insertion/"
      }}>{`Bulk Data Insertion API`}</a>{` are both methods to submit server-side collection data to Adobe Analytics. Data Insertion API calls are made one event at a time. Bulk Data Insertion API accepts CSV formatted files containing event data, one event per row. If you are working on a new implementation of server-side collection, Adobe recommends using the Bulk Data Insertion API.`}</p>
    <p>{`The Data Insertion API supports `}<inlineCode parentName="p">{`GET`}</inlineCode>{` and `}<inlineCode parentName="p">{`POST`}</inlineCode>{` API calls.`}</p>
    <h2 {...{
      "id": "http-post"
    }}>{`HTTP POST`}</h2>
    <p>{`Sending `}<inlineCode parentName="p">{`POST`}</inlineCode>{` API calls requires an XML body containing the desired variables. JSON body is not yet supported.`}</p>
    <CodeBlock slots="heading, code" repeat="2" languages="CURL,XML" mdxType="CodeBlock" />
    <h4 {...{
      "id": "request"
    }}>{`Request`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`curl -X POST "https://example.sc.omtrdc.net/b/ss//6" \\
    -H "Accept: application/xml" \\
    -H "Content-Type: application/xml" \\
    -d "<?xml version=1.0 encoding=UTF-8?>
        <request>
            <pageURL>https://example.com</pageURL>
            <pageName>Data Insertion API test (POST)</pageName>
            <visitorID>1286556420966514130</visitorID>
            <reportSuiteID>examplersid</reportSuiteID>
        </request>"
`}</code></pre>
    <h4 {...{
      "id": "response"
    }}>{`Response`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-xml"
      }}>{`<?xml version="1.0" encoding="UTF-8"?>
<status>SUCCESS</status>
`}</code></pre>
    <h2 {...{
      "id": "http-get"
    }}>{`HTTP GET`}</h2>
    <p>{`Sending `}<inlineCode parentName="p">{`GET`}</inlineCode>{` API calls requires the desired variables in the URL's query string. Sending data via `}<inlineCode parentName="p">{`GET`}</inlineCode>{` reduces bandwidth, but does not provide a detailed response.`}</p>
    <CodeBlock slots="heading, code" repeat="2" languages="CURL,HTTP" mdxType="CodeBlock" />
    <h4 {...{
      "id": "request-1"
    }}>{`Request`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`curl -X GET "https://example.sc.omtrdc.net/b/ss/examplersid/0?g=https%3A%2F%2Fexample%2Ecom&pageName=Data%20Insertion%20API%20test%20%28GET%29&vid=1286556420966514130"
`}</code></pre>
    <h4 {...{
      "id": "response-1"
    }}>{`Response`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-text"
      }}>{`200 OK
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      